<template>
  <!-- ======= Idef Section ======= -->
  <section id="about" class="about"></section>

  <div class="idef">
    <h1>IDEF 21</h1>
    <h3>IDEF 2021 FUARINDA SİZLERİ SALON 10 – STANT 1000’DE BEKLİYORUZ.</h3>
    <img src="@/assets/idef.jpg" style="max-width: 800px; width: 70%" />
  </div>

  <!--End About Section -->
</template>

<script>
export default {
  name: "Idef",
};
</script>

<style scoped>
.idef {
  padding-bottom: 0px;
}
.idef h3 {
  margin-bottom: 50px;
}
</style>
